import { NonTypeTab, type TemplateTab } from '../types/TemplateTabs';

export const isAllTabInUse = (activeTabId: TemplateTab) =>
  activeTabId === NonTypeTab.ALL;
